import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";

export default {
  getSettings: () => request(METHODS.GET, API.SETTINGS.GET_SETTINGS)(),
  updateSetting: (key: string, value: number) =>
    request(METHODS.PUT, API.SETTINGS.UPDATE_SETTING(key))({ setting_value: value }),
};
